import trackItemChanges from '../helpers/trackItemChanges'
import calcItemTotalEnc from '@/helpers/calcItemTotalEnc'
import store from '../store/index'
import { getEffectiveItemType, getItemPropertySource } from '../helpers/getEffectiveItemType'
import getCharacterArmourDexPen from '../helpers/getCharacterArmourDexPen'
import loadTraits from '../helpers/loadTraits'

function getArmourSourceStaticItem(item) {
  const getStaticItemById = store.getters?.['characters/getStaticItemById']
  if (typeof getStaticItemById !== 'function' || !item?.item) {
    return null
  }

  const staticItem = getStaticItemById(item.item)
  return staticItem ? getItemPropertySource(staticItem, getStaticItemById) : null
}

function isEffectiveArmourItem(item) {
  if (!item) return false
  if (item.type === 'Armour') return true

  const getStaticItemById = store.getters?.['characters/getStaticItemById']
  if (typeof getStaticItemById !== 'function' || !item.item) {
    return false
  }

  const staticItem = getStaticItemById(item.item)
  return getEffectiveItemType(staticItem, getStaticItemById) === 'Armour'
}
//------------------------------
// process specific item change
//------------------------------
export default function processSpecificItemChange({
  change = null, // not required for new character item
  item,
  original_items,
  changed_items,
  character,
}) {
  console.log('------------------------')
  console.log('IN processSpecificItemChange')
  console.log('1. item = ' + item.name)
  console.log('2. original_items = ', window.$deepCopy(original_items))
  console.log('3. changed_items = ', window.$deepCopy(changed_items))
  console.log('4. change = ', change)
  console.log('5. change.key = ' + change?.key)
  console.log('6. change.value = ' + change?.value)
  // console.log('character skills = ', character.skills)
  let calc_container_contents = null
  let remove_equipped_armour = null
  let add_equipped_armour = null
  let clear_item = null
  //------------------------------------------------------
  // keep the in-memory character item in sync with change
  //------------------------------------------------------
  if (change && item && Object.prototype.hasOwnProperty.call(change, 'key')) {
    // Mirror simple field changes (including artefact static lookups
    // like currency) onto the character item so that table views and
    // subsequent ItemCard sessions see the latest value immediately.
    item[change.key] = change.value
  }
  //--------------------------------------------
  // track item changes (performed in ItemCard)
  //--------------------------------------------
  changed_items = trackItemChanges({
    change,
    item,
    original_items,
    changed_items,
    character_id: character.id,
  })
  console.log('3. changed_items = ', window.$deepCopy(changed_items))
  //============================================================================
  // A. where change = tally_qty
  //-----------------------------
  if (change.key == 'tally_qty') {
    //---------------------------------
    // re/calc total enc for THIS item
    //---------------------------------
    console.log(`A1. ${item.name} tally_qty changed ${change.value} so recalc total enc`)
    item.tot_enc = calcItemTotalEnc({ character_item: item })
    console.log(`A2. ${item.name} new tot_enc = ${item.tot_enc}`)
    //------------------------------------------------------------------
    // if this item is inside a container, that container's contents ENC
    // and counts need to be recalculated (and will bubble up parents).
    //------------------------------------------------------------------
    if (item.container != null) {
      calc_container_contents = item.container
      console.log(
        `A3. ${item.name} is in container id = ${item.container}, will recalc that container`,
      )
    }
    //-----------------------------------------------------
    // where tally qty = 0 - clear any attached runes/adjs
    //-----------------------------------------------------
    if (change.value == 0) {
      console.log(`A4. ${item.name} tally_qty is 0, will clear any attached runes/adjs`)
      // clear any attached runes/adjs
      console.log(`A5. item prior to clear = `, item)
      console.log(`A6. character prior to clear = `, character)
      clear_item = item.id
      console.log(`A7. clear_item id = `, clear_item)
    }
    //============================================================================
    // B. where change = container
    //-----------------------------
  } else if (change.key == 'container') {
    //---------------------------------------------------
    // work out which container needs contents recalcing
    //---------------------------------------------------
    if (change.value == null) {
      // container cleared: recalc the previous container this item was in
      const prevContainerId = change.previousValue ?? null
      calc_container_contents = prevContainerId
      console.log(
        `B1. ${item.name} container cleared, will recalc previous container id = ${prevContainerId}`,
      )
    } else {
      // container set/changed: recalc the new container id
      calc_container_contents = change.value
      console.log(
        `B1. ${item.name} container changed to ${change.value}, will recalc that container`,
      )
    }
    //============================================================================
    // C. where change = enc
    //-----------------------
  } else if (change.key === 'enc') {
    //---------------------------------
    // re/calc total enc for THIS item
    //---------------------------------
    item.tot_enc = calcItemTotalEnc({ character_item: item })

    //------------------------------------------------------------------
    // if this item is inside a container, that container's contents ENC
    // and counts need to be recalculated (and will bubble up parents).
    //------------------------------------------------------------------
    if (item.container != null) {
      calc_container_contents = item.container
    }
    //============================================================================
    // D. where change = equipped (armour)
    //-------------------------------------
  } else if (change.key == 'equipped') {
    //------------------------
    // where now NOT equipped
    //------------------------
    if (change.value == false) {
      remove_equipped_armour = item.id
      console.log(`C1. ${item.name} equipped false - remove equipped armour`)
    } else {
      //--------------------
      // where now EQUIPPED
      //--------------------
      add_equipped_armour = item.id
      console.log(`C2. ${item.name} equipped true - add equipped armour`)

      // when equipping armour, ensure headline armour fields on the
      // character item are populated from the static definition so
      // that the armour table can display coverage/AP/HP/layer
      // immediately after the change.
      if (isEffectiveArmourItem(item)) {
        try {
          const staticItem = getArmourSourceStaticItem(item)

          if (staticItem && staticItem.armour && staticItem.armour.armour_material) {
            const hasAp = item.ap !== undefined && item.ap !== null
            const hasHp = item.hp !== undefined && item.hp !== null
            const hasLayer = item.layer !== undefined && item.layer !== null

            if (!hasAp) {
              item.ap = staticItem.armour.armour_material.ap ?? null
            }
            if (!hasHp) {
              item.hp = staticItem.armour.armour_material.hp ?? null
            }
            if (!hasLayer) {
              item.layer = staticItem.armour.armour_material.layer ?? null
            }

            // keep original coverage behaviour: allow static coverage
            // to pre-populate item.coverage when present
            if (staticItem.armour.coverage) {
              item.coverage = staticItem.armour.coverage ?? item.coverage ?? ''
            }
          }
        } catch (e) {
          console.warn('Unable to hydrate armour headline fields on equip:', e)
        }
      }
    }
    //============================================================================
    // E. where change = armour AP
    //-------------------------------------
  } else if (change.key === 'ap' && isEffectiveArmourItem(item)) {
    // For armour items, keep the per-item dex penalty in sync with the
    // current AP before the change set is persisted / sent to the API.
    //
    // We mirror the logic used in ItemCard: treat the original static
    // dex_pen as proportional to the static material AP and scale
    // linearly based on the new character-item AP.
    try {
      const staticItem = getArmourSourceStaticItem(item)

      if (staticItem && staticItem.armour && staticItem.armour.armour_material) {
        const materialAp = Number(staticItem.armour.armour_material.ap) || 0
        const baseDexPen = Number(staticItem.armour.dex_pen) || 0

        if (materialAp > 0 && baseDexPen >= 0) {
          const newAp = Number(change.value) || 0
          const ratio = newAp / materialAp
          if (!Number.isNaN(ratio)) {
            item.dex_pen = baseDexPen * ratio
          }
        }

        //------------------------------------------------------------------
        // Where this armour is CURRENTLY EQUIPPED, also refresh any
        // frontend armour-location aggregates so that the character-level
        // dex_pen_percent_armour (and location dex_pen / highest_ap) stay
        // in sync immediately after the AP tweak, mirroring backend
        // CharacterLocationEquippedArmour.get_armour_dex_pen_percent and
        // get_dex_pen_percent_armour.
        //------------------------------------------------------------------
        if (item.equipped && character && Array.isArray(character.armour_locations)) {
          const newAp = Number(change.value) || 0
          const dexPenFactor = Number(staticItem.armour.armour_material.dex_pen_factor) || 0

          // 1) Update per-location equipped_armour entries that reference
          //    this character item (by id) with the new AP and dex_pen.
          character.armour_locations.forEach((loc) => {
            if (!loc || !Array.isArray(loc.equipped_armour)) return

            let locationChanged = false

            loc.equipped_armour.forEach((ea) => {
              if (!ea || ea.armour !== item.id) return

              // Update the per-location AP for this piece
              ea.ap = newAp

              // Mirror backend per-location dex pen:
              //   pen = ap * dex_pen_factor
              //   halved for half-locations.
              let pen = newAp * dexPenFactor
              if (loc.half_location) {
                pen = pen / 2
              }
              ea.dex_pen = pen
              locationChanged = true
            })

            // 2) If any entry at this location changed, recalc the
            //    CharacterArmourLocation-like aggregates: armour_count,
            //    highest_ap, highest_layer, dex_pen.
            if (locationChanged) {
              const equipped = Array.isArray(loc.equipped_armour) ? loc.equipped_armour : []

              const armour_count = equipped.filter((ea) => ea && ea.armour != null).length

              let highest_ap = 0
              let highest_layer = 0
              let dex_pen_total = 0

              equipped.forEach((ea) => {
                if (!ea) return

                const apVal = Number(ea.ap) || 0
                if (apVal > highest_ap) highest_ap = apVal

                const layerVal = Number(ea.layer)
                if (!Number.isNaN(layerVal) && layerVal > highest_layer) {
                  highest_layer = layerVal
                }

                const dpVal = Number(ea.dex_pen) || 0
                dex_pen_total += dpVal
              })

              loc.armour_count = armour_count
              loc.highest_ap = highest_ap
              loc.highest_layer = highest_layer
              loc.dex_pen = dex_pen_total
            }
          })
        }

        //------------------------------------------------------------------
        // 3) Recompute the character-wide armour dex penalty percentage
        //    from the current armour-location aggregates so fixed coverage
        //    armour matches the backend coverage-weighted total.
        //------------------------------------------------------------------
        if (character) {
          character.dex_pen_percent_armour = getCharacterArmourDexPen(character)
        }
      }
    } catch (e) {
      console.warn('Unable to recalc dex_pen for armour AP change:', e)
    }
  } else if (change.key === 'hp' && isEffectiveArmourItem(item)) {
    try {
      if (item.equipped && character && Array.isArray(character.armour_locations)) {
        const newHp = Number(change.value)

        character.armour_locations.forEach((loc) => {
          if (!loc || !Array.isArray(loc.equipped_armour)) return

          loc.equipped_armour.forEach((ea) => {
            if (!ea || ea.armour !== item.id) return
            ea.hp = Number.isNaN(newHp) ? change.value : newHp
          })
        })
      }
    } catch (e) {
      console.warn('Unable to sync armour HP change:', e)
    }
  }

  if (['item', 'name', 'display_name'].includes(change?.key)) {
    character = loadTraits({ character })
  }
  //----------------------
  // return changed items
  //----------------------
  return {
    changed_items,
    calc_container_contents,
    clear_item,
    remove_equipped_armour,
    add_equipped_armour,
  }
}
